import type { ProductCatalogPlanColumn, ProductCatalogPlanRow } from "../../lib/productCatalog";

type PlanTableProps = {
  rows: ProductCatalogPlanRow[];
  ariaLabel: string;
  columns: ProductCatalogPlanColumn[];
};

export function PlanTable({ rows, ariaLabel, columns }: PlanTableProps) {
  return (
    <div className="legal-plan-table-scroll overflow-x-auto rounded-2xl border border-[#EADBC8]">
      <table aria-label={ariaLabel} className="w-full min-w-[38rem] border-collapse bg-white text-left text-xs leading-6 md:min-w-0">
        <thead className="bg-[#FDF8F5] text-[#5D4D46]">
          <tr>
            <th scope="col" className="px-3 py-3 font-bold md:w-[22%]">
              機能
            </th>
            {columns.map((column) => (
              <th key={column.key} scope="col" className="px-3 py-3 font-bold">
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-[#EADBC8]">
          {rows.map((row) => (
            <tr key={row.feature}>
              <th scope="row" className="break-keep px-3 py-3 font-bold text-[#5D4D46]">
                <span>{row.feature}</span>
                {row.description ? (
                  <span className="mt-1 block whitespace-normal break-words text-[11px] font-medium leading-5 text-[#8A756C]">
                    {row.description}
                  </span>
                ) : null}
              </th>
              {columns.map((column) => (
                <td key={column.key} className="break-keep px-3 py-3 align-top">
                  {row.values[column.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
